/**
 * @ngdoc component
 * @name home.component:itxWorldwideSearch
 * @description
 * Search countries in the worldwide page.
 */
(function () {
    'use strict';

    var itxWorldwideSearch = {
        bindings: {
            storeList: '<',
            searchCountry: '<',
            onSelectStore: '&',
            traductions: '<'
        },
        controller: itxWorldwideSearchCtrl,
        templateUrl: 'worldwide-search.component.html'
    };

    function itxWorldwideSearchCtrl() {

        var _this = this;

        _this.focusInput = function (e) {
            e.currentTarget.parentElement.classList.add('focused');
        };

        _this.blurInput = function (e) {
            //animacion para placeholders aunque ahora no lo estamos usando
            var inputValue = e.currentTarget.value;
            if (inputValue == '') {
                e.currentTarget.classList.remove('filled');
                e.currentTarget.parentElement.classList.remove('focused');
            } else {
                e.currentTarget.classList.add('filled');
            }
        };

        _this.clickOutsideSearch = function () {
            _this.searchCountry = '';
        };
    }

    angular.module('itxApp.home').component('itxWorldwideSearch', itxWorldwideSearch);
})();
